import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React from 'react';
import {useCreateOrganizationDrawerState} from '../state/create-organization-drawer-state';

export type Props = {
  createOrganization: (name: string, publicKey: string) => Promise<void>
  isDrawerOpen: boolean
  onDrawerClosed: () => void
}

export const CreateOrganizationDrawer = (props: Props) => {
  const state = useCreateOrganizationDrawerState(props)

  const buildOrganizationNameInput = () =>  <TextField
    label={state.translateLocal('organizationName')}
    value={state.organizationName}
    onChange={(e) => state.setOrganizationName(e.target.value)}
    required
    fullWidth
  />

  const buildOrganizationPublicKeyInput = () => <TextField
    label={state.translateLocal('organizationPublicKey')}
    value={state.organizationPublicKey}
    onChange={(e) => state.setOrganizationPublicKey(e.target.value)}
    required
    multiline
    minRows={5}
    fullWidth
  />

  return <Drawer
    anchor="right"
    open={props.isDrawerOpen}
    onClose={state.closeDrawer}
    PaperProps={{
      sx: {
        width: 480,
        marginTop: '64px',
        height: `calc(100% - 64px)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <h2>{state.translateLocal('title')}</h2>
    <form onSubmit={async (event) => {
      event.preventDefault();
      await state.handleSubmit();
    }}
    >
      <Stack spacing={3}>
        {buildOrganizationNameInput()}
        {buildOrganizationPublicKeyInput()}
        <Button type="submit"
                variant="contained"
                color="primary"
                disabled={state.saveButtonDisabled}
        >
          {state.translate('common.save.title')}
        </Button>
        <Button variant="outlined"
                onClick={state.closeDrawer}
        >
          {state.translate('common.cancel.title')}
        </Button>
      </Stack>
    </form>
  </Drawer>
}